import { Helmet } from "react-helmet-async";

const BASE = "https://ecroplyai.in";
const OG_IMAGE = `${BASE}/favicon-512.png`;

export function Seo({ title, description, path = "/", faq, breadcrumb, jsonLd, ogImage }) {
  const url = `${BASE}${path}`;
  const og = ogImage ? `${BASE}${ogImage}` : OG_IMAGE;
  const graphs = [];
  if (faq && faq.length) {
    graphs.push({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faq.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
  }
  if (breadcrumb && breadcrumb.length) {
    graphs.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumb.map((b, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: b.name,
        item: `${BASE}${b.path}`,
      })),
    });
  }
  if (jsonLd && jsonLd.length) graphs.push(...jsonLd);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Ecroply AI" />
      <meta property="og:image" content={og} />
      <meta name="twitter:image" content={og} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {graphs.map((g, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(g)}</script>
      ))}
    </Helmet>
  );
}
